import { render, staticRenderFns } from "./VisitShopDetailStatus.vue?vue&type=template&id=39f22448&scoped=true&"
import script from "./VisitShopDetailStatus.vue?vue&type=script&lang=js&"
export * from "./VisitShopDetailStatus.vue?vue&type=script&lang=js&"
import style0 from "./VisitShopDetailStatus.vue?vue&type=style&index=0&id=39f22448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f22448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCol,VIcon,VRow,VTooltip})
